import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MedicineService } from 'src/core/services/medicine.service';
import { CreateDosageUnitPayload, DosageUnit } from 'src/interfaces/medicine';

export interface DialogData {
  title: string;
  message: string;
}

@Component({
    selector: 'app-dosage-unit-create-dialog',
    templateUrl: './dosage-unit-create-dialog.component.html',
    styleUrls: ['./dosage-unit-create-dialog.component.scss'],
    standalone: false
})
export class DosageUnitCreateDialogComponent implements OnInit {
  dosageUnitForm = this._formBuilder.group({
    unit: ['', Validators.required],
    symbol: ['', Validators.required],
    code: ['', Validators.required]
  });

  createdDosageUnit: DosageUnit | null = null;
  constructor(
    public _dialogRef: MatDialogRef<DosageUnitCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _formBuilder: UntypedFormBuilder,
    private _medicineService: MedicineService
  ) { }

  ngOnInit(): void {

  }

  async createDosageUnit() {
    const payload: CreateDosageUnitPayload = {
      unit: this.dosageUnitForm.value.unit,
      symbol: this.dosageUnitForm.value.symbol,
      code: this.dosageUnitForm.value.code
    }

    this.createdDosageUnit = await this._medicineService
      .createDosageUnit(payload);

    if (this.createdDosageUnit) 
      this._dialogRef.close(this.createdDosageUnit);
  
  }

}
